import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import { useEffect } from "react";
import { Heading, Text } from "../shared";
import styles from "./generic-teaser.module.css";
export const GenericTeaser = (blok)=>{
    const { title , body  } = blok;
    useEffect(()=>{
        if (title === "test") {
            throw new Error("hell now");
        }
    }, [
        title
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        ...storyblokEditable(blok),
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                className: styles.heading,
                children: title
            }),
            /*#__PURE__*/ _jsx(Text, {
                children: body
            })
        ]
    });
};
